import { useDocumentVisibility, useRafInterval, useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';

import { inExpireTime } from './../login/login';

const TIME = 1000 * 30; // 30s 自动保存

interface IProps {
  save?: Function;
  start?: boolean;
  timeout?: number;
}
/**
 * 自动保存
 */
export const UseAutoSave = (props: IProps) => {
  const { save, start, timeout = 0 } = props;
  const [time, setTime] = useState('');

  const documentVisibility = useDocumentVisibility() === 'visible';

  const canSave = inExpireTime();

  const clear = useRafInterval(() => {
    const now = dayjs();
    const diff = now.diff(dayjs(`${now.format('YYYY-MM-DD')} ${time}`));

    if (documentVisibility && start && canSave && diff > 5000) {
      save?.();
      setTime(now.format('HH:mm:ss'));
    }
  }, (timeout * 1000) || TIME, { immediate: false });

  useEffect(() => () => {
    clear?.();
  }, [clear]);

  const refresh = useCallback(async () => {
    const now = dayjs();
    const diff = now.diff(dayjs(`${now.format('YYYY-MM-DD')} ${time}`));

    if (start && canSave && diff > 5000) {
      save?.();
      setTime(dayjs().format('HH:mm:ss'));
    }
  }, [start, save, canSave, time]);

  useRequest(refresh, {
    refreshOnWindowFocus: true,
    focusTimespan: 5000,
  });

  return { time };
};
